/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrintReceiptRequest
 */
export interface PrintReceiptRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintReceiptRequest
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof PrintReceiptRequest
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof PrintReceiptRequest
     */
    title: string;
}

/**
 * Check if a given object implements the PrintReceiptRequest interface.
 */
export function instanceOfPrintReceiptRequest(value: object): value is PrintReceiptRequest {
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function PrintReceiptRequestFromJSON(json: any): PrintReceiptRequest {
    return PrintReceiptRequestFromJSONTyped(json, false);
}

export function PrintReceiptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintReceiptRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'],
        'terminalId': json['terminalId'],
        'title': json['title'],
    };
}

export function PrintReceiptRequestToJSON(json: any): PrintReceiptRequest {
    return PrintReceiptRequestToJSONTyped(json, false);
}

export function PrintReceiptRequestToJSONTyped(value?: PrintReceiptRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
        'terminalId': value['terminalId'],
        'title': value['title'],
    };
}

